import React from "react";
import Footer from "../components/SectionsLP/Footer";
import Header from "../components/Header";
import heroDivider from "./../assets/septImages/heroDivider.png";
import coverDeal from "./../assets/septImages/coverDeal.png";
import dealIndex1 from "./../assets/septImages/dealFeatureIndex01.png";
import dealIndex2 from "./../assets/septImages/dealFeatureIndex02.png";
import dealIndex3 from "./../assets/septImages/dealFeatureIndex03.png";
import dealIndex4 from "./../assets/septImages/dealFeatureIndex04.png";
import dealIconHammer from "./../assets/septImages/dealIconHammer.svg";
import dealIconHands from "./../assets/septImages/dealIconHands.svg";
import dealIconSheild from "./../assets/septImages/dealIconSheild.svg";
import dealIconSetting from "./../assets/septImages/dealIconCog.png";
import dealDigitalHuman from "./../assets/septImages/dealFeatureHuman.svg";
// import dealIconSetting from "./../assets/septImages/bgStructure.png";
import "./DealRoom.css";
import kyc from "../assets/kyc.png";
import kycnew from "../assets/KycNew.png";

const KycAml = () => {
  return (
    <div className="KycAml">
      <Header active="1" />

      {/*  _BEGIN > DEAL HERO SECTION < SHB */}
      <section className="shbSectionDealHero">
        <div className="container shbPageContainer g-sm-0">
          <div className="shbBodyContainer">
            <div className="row align-items-center position-relative">
              <div className="col-lg-6">
                <div className="shbHeroHeader">
                  <h1 className="shbHeroHeading">
                    Automated and reliable <span>policy enforcement</span>
                  </h1>
                  <div className="shbHeroDivider">
                    <img src={heroDivider} alt="divider-line" className="" />
                  </div>
                  <p className="shbHeroText">
                    Fully customizable and configurable access control policy
                    engine to protect funds and assets against insider threats
                    and simplifying operations and governance
                  </p>
                  <div className="shbDealKey">
                    <svg
                      className="svgkey"
                      width="620"
                      height="248"
                      viewBox="0 0 620 248"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_5251_2439)">
                        <mask
                          id="path-1-outside-1_5251_2439"
                          maskUnits="userSpaceOnUse"
                          x="19.9967"
                          y="20.9996"
                          width="575.035"
                          height="198.101"
                          fill="black"
                        >
                          <rect
                            fill="white"
                            x="19.9967"
                            y="20.9996"
                            width="575.035"
                            height="198.101"
                          ></rect>
                          <path d="M568.003 96.2902L333.481 96.2489L333.482 94.8802C333.482 92.9392 332.61 91.0773 331.057 89.7034C329.505 88.3295 327.398 87.5559 325.2 87.5525L319.991 87.5516C317.793 87.5542 315.686 88.3271 314.133 89.7004C312.58 91.0738 311.707 92.9353 311.707 94.8764L311.707 96.245L292.029 96.2416L292.029 94.8729C292.031 93.9114 291.818 92.9589 291.403 92.0701C290.987 91.1812 290.377 90.3733 289.608 89.6927C288.839 89.0121 287.926 88.4721 286.92 88.1036C285.914 87.7351 284.836 87.5454 283.747 87.5452L278.538 87.5443C276.338 87.5439 274.228 88.3154 272.672 89.689C271.116 91.0627 270.241 92.926 270.241 94.8691L270.241 96.2377L243.634 96.2331L234.077 88.9166C232.397 87.6281 230.262 86.8957 228.038 86.845C225.814 86.7942 223.639 87.4282 221.887 88.6384L216 92.7088C214.925 93.4526 213.684 93.9851 212.357 94.2708C211.031 94.5564 209.651 94.5886 208.31 94.3651C206.968 94.1417 205.696 93.6677 204.579 92.975C203.461 92.2823 202.525 91.3869 201.831 90.3486L184.645 64.6632C168.748 39.3576 142.001 23.0211 111.097 23.0157C61.153 23.0069 22.0238 65.5547 22.0142 119.944C22.0046 174.334 61.0667 216.907 111.063 216.915C146.317 216.922 176.183 195.684 190.683 164.024C193.832 157.15 197.555 150.492 201.821 144.105C202.515 143.067 203.453 142.172 204.57 141.48C205.688 140.788 206.96 140.314 208.302 140.091C209.643 139.868 211.023 139.901 212.349 140.187C213.675 140.473 214.917 141.006 215.991 141.75L221.877 145.811C223.626 147.026 225.801 147.664 228.025 147.616C230.25 147.568 232.386 146.837 234.067 145.549L243.627 138.236L270.233 138.24L270.233 139.609C270.233 140.571 270.447 141.523 270.864 142.411C271.281 143.299 271.892 144.106 272.663 144.786C273.433 145.465 274.348 146.004 275.354 146.371C276.36 146.738 277.439 146.927 278.528 146.925L283.737 146.926C284.825 146.928 285.903 146.74 286.909 146.373C287.914 146.006 288.828 145.468 289.598 144.788C290.367 144.109 290.978 143.302 291.393 142.414C291.809 141.526 292.022 140.574 292.021 139.613L292.021 138.244L311.699 138.248L311.699 139.616C311.699 141.556 312.571 143.417 314.124 144.789C315.677 146.161 317.784 146.932 319.98 146.933L325.19 146.933C327.386 146.934 329.493 146.164 331.047 144.792C332.6 143.421 333.473 141.56 333.474 139.62L333.474 138.251L443.859 138.271L443.848 199.228C443.848 199.708 443.955 200.184 444.163 200.627C444.371 201.071 444.676 201.474 445.061 201.814C445.445 202.154 445.902 202.423 446.404 202.607C446.906 202.791 447.445 202.886 447.989 202.886L458.407 202.888C459.506 202.888 460.559 202.503 461.336 201.817C462.113 201.131 462.549 200.201 462.549 199.231L462.552 184.659C462.552 183.689 462.989 182.759 463.765 182.073C464.542 181.387 465.596 181.002 466.694 181.002L474.508 181.004C475.052 181.004 475.59 180.909 476.093 180.725C476.595 180.542 477.052 180.272 477.436 179.933C477.821 179.593 478.126 179.19 478.334 178.746C478.543 178.303 478.65 177.827 478.65 177.347L478.651 169.572C478.651 168.602 479.088 167.672 479.865 166.986C480.641 166.3 481.695 165.915 482.793 165.915L507.655 165.92C508.753 165.92 509.806 166.305 510.583 166.991C511.359 167.677 511.795 168.608 511.795 169.578L511.794 177.353C511.794 177.833 511.901 178.309 512.109 178.752C512.317 179.196 512.622 179.599 513.006 179.939C513.391 180.279 513.847 180.548 514.35 180.732C514.852 180.916 515.391 181.011 515.935 181.011L523.749 181.012C524.294 181.011 524.833 181.104 525.337 181.288C525.841 181.471 526.299 181.74 526.685 182.08C527.071 182.42 527.377 182.823 527.586 183.268C527.795 183.712 527.902 184.189 527.902 184.67L527.9 199.3C527.9 200.27 528.336 201.2 529.112 201.886C529.889 202.572 530.942 202.958 532.04 202.958L542.459 202.96C543.557 202.96 544.611 202.575 545.388 201.889C546.164 201.203 546.601 200.273 546.601 199.303L546.612 138.347L569.012 138.35C572.152 138.324 575.254 137.75 578.142 136.661C581.03 135.572 583.645 133.99 585.839 132.006C588.032 130.022 589.759 127.674 590.922 125.099C592.085 122.523 592.66 119.769 592.614 116.997C592.368 105.369 581.118 96.2925 568.003 96.2902ZM111.133 187.668C80.242 187.662 55.2037 157.352 55.2103 119.973C55.2169 82.5939 80.2659 52.304 111.157 52.3094C142.048 52.3148 167.073 82.6136 167.067 119.993C167.06 157.372 142.011 187.685 111.133 187.679L111.133 187.668Z"></path>
                        </mask>
                        <path
                          d="M568.003 96.2902L333.481 96.2489L333.482 94.8802C333.482 92.9392 332.61 91.0773 331.057 89.7034C329.505 88.3295 327.398 87.5559 325.2 87.5525L319.991 87.5516C317.793 87.5542 315.686 88.3271 314.133 89.7004C312.58 91.0738 311.707 92.9353 311.707 94.8764L311.707 96.245L292.029 96.2416L292.029 94.8729C292.031 93.9114 291.818 92.9589 291.403 92.0701C290.987 91.1812 290.377 90.3733 289.608 89.6927C288.839 89.0121 287.926 88.4721 286.92 88.1036C285.914 87.7351 284.836 87.5454 283.747 87.5452L278.538 87.5443C276.338 87.5439 274.228 88.3154 272.672 89.689C271.116 91.0627 270.241 92.926 270.241 94.8691L270.241 96.2377L243.634 96.2331L234.077 88.9166C232.397 87.6281 230.262 86.8957 228.038 86.845C225.814 86.7942 223.639 87.4282 221.887 88.6384L216 92.7088C214.925 93.4526 213.684 93.9851 212.357 94.2708C211.031 94.5564 209.651 94.5886 208.31 94.3651C206.968 94.1417 205.696 93.6677 204.579 92.975C203.461 92.2823 202.525 91.3869 201.831 90.3486L184.645 64.6632C168.748 39.3576 142.001 23.0211 111.097 23.0157C61.153 23.0069 22.0238 65.5547 22.0142 119.944C22.0046 174.334 61.0667 216.907 111.063 216.915C146.317 216.922 176.183 195.684 190.683 164.024C193.832 157.15 197.555 150.492 201.821 144.105C202.515 143.067 203.453 142.172 204.57 141.48C205.688 140.788 206.96 140.314 208.302 140.091C209.643 139.868 211.023 139.901 212.349 140.187C213.675 140.473 214.917 141.006 215.991 141.75L221.877 145.811C223.626 147.026 225.801 147.664 228.025 147.616C230.25 147.568 232.386 146.837 234.067 145.549L243.627 138.236L270.233 138.24L270.233 139.609C270.233 140.571 270.447 141.523 270.864 142.411C271.281 143.299 271.892 144.106 272.663 144.786C273.433 145.465 274.348 146.004 275.354 146.371C276.36 146.738 277.439 146.927 278.528 146.925L283.737 146.926C284.825 146.928 285.903 146.74 286.909 146.373C287.914 146.006 288.828 145.468 289.598 144.788C290.367 144.109 290.978 143.302 291.393 142.414C291.809 141.526 292.022 140.574 292.021 139.613L292.021 138.244L311.699 138.248L311.699 139.616C311.699 141.556 312.571 143.417 314.124 144.789C315.677 146.161 317.784 146.932 319.98 146.933L325.19 146.933C327.386 146.934 329.493 146.164 331.047 144.792C332.6 143.421 333.473 141.56 333.474 139.62L333.474 138.251L443.859 138.271L443.848 199.228C443.848 199.708 443.955 200.184 444.163 200.627C444.371 201.071 444.676 201.474 445.061 201.814C445.445 202.154 445.902 202.423 446.404 202.607C446.906 202.791 447.445 202.886 447.989 202.886L458.407 202.888C459.506 202.888 460.559 202.503 461.336 201.817C462.113 201.131 462.549 200.201 462.549 199.231L462.552 184.659C462.552 183.689 462.989 182.759 463.765 182.073C464.542 181.387 465.596 181.002 466.694 181.002L474.508 181.004C475.052 181.004 475.59 180.909 476.093 180.725C476.595 180.542 477.052 180.272 477.436 179.933C477.821 179.593 478.126 179.19 478.334 178.746C478.543 178.303 478.65 177.827 478.65 177.347L478.651 169.572C478.651 168.602 479.088 167.672 479.865 166.986C480.641 166.3 481.695 165.915 482.793 165.915L507.655 165.92C508.753 165.92 509.806 166.305 510.583 166.991C511.359 167.677 511.795 168.608 511.795 169.578L511.794 177.353C511.794 177.833 511.901 178.309 512.109 178.752C512.317 179.196 512.622 179.599 513.006 179.939C513.391 180.279 513.847 180.548 514.35 180.732C514.852 180.916 515.391 181.011 515.935 181.011L523.749 181.012C524.294 181.011 524.833 181.104 525.337 181.288C525.841 181.471 526.299 181.74 526.685 182.08C527.071 182.42 527.377 182.823 527.586 183.268C527.795 183.712 527.902 184.189 527.902 184.67L527.9 199.3C527.9 200.27 528.336 201.2 529.112 201.886C529.889 202.572 530.942 202.958 532.04 202.958L542.459 202.96C543.557 202.96 544.611 202.575 545.388 201.889C546.164 201.203 546.601 200.273 546.601 199.303L546.612 138.347L569.012 138.35C572.152 138.324 575.254 137.75 578.142 136.661C581.03 135.572 583.645 133.99 585.839 132.006C588.032 130.022 589.759 127.674 590.922 125.099C592.085 122.523 592.66 119.769 592.614 116.997C592.368 105.369 581.118 96.2925 568.003 96.2902ZM111.133 187.668C80.242 187.662 55.2037 157.352 55.2103 119.973C55.2169 82.5939 80.2659 52.304 111.157 52.3094C142.048 52.3148 167.073 82.6136 167.067 119.993C167.06 157.372 142.011 187.685 111.133 187.679L111.133 187.668Z"
                          stroke="url(#paint0_radial_5251_2439)"
                          strokeWidth="4"
                          shape-rendering="crispEdges"
                          mask="url(#path-1-outside-1_5251_2439)"
                        ></path>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_5251_2439"
                          x="-4.98438"
                          y="0.015625"
                          width="624.602"
                          height="247.898"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          ></feFlood>
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          ></feColorMatrix>
                          <feOffset dy="4"></feOffset>
                          <feGaussianBlur stdDeviation="12.5"></feGaussianBlur>
                          <feComposite
                            in2="hardAlpha"
                            operator="out"
                          ></feComposite>
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.79 0"
                          ></feColorMatrix>
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_5251_2439"
                          ></feBlend>
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_5251_2439"
                            result="shape"
                          ></feBlend>
                        </filter>
                        <radialGradient
                          id="paint0_radial_5251_2439"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(592.622 105.286) rotate(-177.302) scale(458.82 174.718)"
                        >
                          <stop stopColor="#219EBC"></stop>
                          <stop
                            offset="0.878206"
                            stopColor="#219EBC"
                            stopOpacity="0"
                          ></stop>
                        </radialGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="shbSectionDealScroll">
                    <span>Scroll</span>
                    <span>
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 1L6 6L1 0.999999"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                {/* <div className="shbHeroAbsoluteCover containImage">
                  <img src={coverDeal} alt="coverdeal" className="" />
          
                </div> */}
                <div className="shbHeroCoverRings">
                  <svg
                    width="980"
                    height="1025"
                    viewBox="0 0 980 1025"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.3">
                      <circle
                        opacity="0.1"
                        cx="322.912"
                        cy="555.582"
                        r="217.589"
                        transform="rotate(-15 322.912 555.582)"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <path
                        opacity="0.1"
                        d="M604.704 480.078C642.575 621.416 558.801 766.666 417.592 804.503C276.383 842.34 131.208 758.437 93.336 617.098C55.4644 475.76 139.238 330.51 280.448 292.673C421.657 254.836 566.832 338.739 604.704 480.078Z"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <path
                        opacity="0.1"
                        d="M681.389 459.53C726.371 627.406 626.849 799.932 459.102 844.88C291.356 889.827 118.904 790.176 73.9218 622.3C28.9397 454.425 128.462 281.898 296.208 236.951C463.955 192.003 636.406 291.654 681.389 459.53Z"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <path
                        opacity="0.1"
                        d="M869.438 409.141C929.804 634.429 796.314 865.94 571.283 926.237C346.253 986.533 114.892 852.784 54.5261 627.496C-5.83964 402.208 127.65 170.697 352.681 110.401C577.711 50.1038 809.072 183.853 869.438 409.141Z"
                        stroke="white"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src={kycnew} className="KycHero"/>
      </section>
      {/*  _ENDS > DEAL HERO SECTION < SHB */}

      {/*  _BEGIN > DEAL FEATURES SECTION < SHB */}
      <section className="shbSectionDealFeature">
        <div className="container shbPageContainer g-sm-0">
          <div className="shbBodyContainer">
            <div className="shbBodySecondaryHeader">
              <h2>Features</h2>
              <p>
                Streamline the dealmaking process with our AI-integrated
                platform by identifying profitable deals, investing, and
                managing them
              </p>
            </div>

            <div className="shbDealFeatureList">
              <div className="shbDealFeatureBoxWrapper shbDealTopSapceOdd">
                <div className="shbDealFeatureBoxIndex">
                  <span> 01 </span>
                </div>
                <div className="shbDealFeatureBox">
                  <div className="shbDealFeatureBoxIcon containImage shbFlexCenter">
                    <img src={dealIconHammer} alt="dealIconHammer" />
                  </div>
                  <div className="shbDealFeatureBoxTitle">
                    Real-time legal structuring
                  </div>
                  <div className="shbDealFeatureBoxText">
                    Make investors' negotiations last hours instead of months by
                    updating your fund's documents in real-time
                  </div>
                </div>
              </div>

              <div className="shbDealFeatureBoxWrapper shbDealTopSapceEven">
                <div className="shbDealFeatureBoxIndex">
                  <span> 02 </span>
                </div>
                <div className="shbDealFeatureBox">
                  <div className="shbDealFeatureBoxIcon containImage shbFlexCenter">
                    <img src={dealIconHands} alt="dealIconHands" />
                  </div>
                  <div className="shbDealFeatureBoxTitle">
                    Swift investor onboarding
                  </div>
                  <div className="shbDealFeatureBoxText">
                    Get investors to subscribe instantly with our streamlined,
                    digital onboarding process
                  </div>
                </div>
              </div>

              <div className="shbDealFeatureBoxWrapper shbDealTopSapceOdd">
                <div className="shbDealFeatureBoxIndex">
                  <span> 03 </span>
                </div>
                <div className="shbDealFeatureBox">
                  <div className="shbDealFeatureBoxIcon containImage shbFlexCenter">
                    <img src={dealIconSheild} alt="dealIconSheild" />
                  </div>
                  <div className="shbDealFeatureBoxTitle">
                    Compliance and security
                  </div>
                  <div className="shbDealFeatureBoxText">
                    Execute deals securely, by bringing all stakeholders to a
                    secure, permissioned online dashboard
                  </div>
                </div>
              </div>

              <div className="shbDealFeatureBoxWrapper shbDealTopSapceEven">
                <div className="shbDealFeatureBoxIndex">
                  <span> 04 </span>
                </div>
                <div className="shbDealFeatureBox">
                  <div className="shbDealFeatureBoxIcon containImage shbFlexCenter">
                    <img src={dealIconSetting} alt="dealIconSetting" />
                  </div>
                  <div className="shbDealFeatureBoxTitle">Smart algorithm</div>
                  <div className="shbDealFeatureBoxText">
                    Our unmatched intelligent algorithm helps you discover
                    appropriate properties that match your requirements, helping
                    you win more business and invest intelligently
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  _ENDS > DEAL FEATURES SECTION < SHB */}

      {/*  _BEGIN > DEAL STRUCTURE SECTION < SHB */}
      <section className="shbSectionDealStructure shbDealStructure">
        <div className="container shbPageContainer g-sm-0 position-relative">
          <div className="shbBodyContainer">
            <div className="shbDigitalHuman">
              <img src={dealDigitalHuman} alt="dealDigitalHuman" />
            </div>

            <div className="shbDealStructureUnity">
              <div className="shbBodySecondaryHeader">
                <h2 className="text-capital">
                  Advanced security and compliance functionalities for
                  organizations
                </h2>
              </div>

              <div className="shbStructureRow">
                <div className="shbStructureConnectorColumn"></div>
                <div className="shbStructureStepsWrap">
                  <div className="shbStructureSteps shbActiveStructureSteps">
                    <div className="shbStructureStepsContentBox">
                      <h3>Unrestricted access</h3>
                      <p>
                        Organizations can create custom rules and private
                        channels to block, approve and request additional
                        authorizers while validating a transaction
                      </p>
                    </div>
                  </div>

                  <div className="shbStructureSteps">
                    <div className="shbStructureStepsContentBox">
                      <h3>Access control list</h3>
                      <p>
                        Leverage our admin access to ACL by setting up user
                        authentication, smart contract parameters, and transfer
                        of funds and assets
                      </p>
                    </div>
                  </div>

                  <div className="shbStructureSteps">
                    <div className="shbStructureStepsContentBox">
                      <h3>One-Click API</h3>
                      <p>
                        Deploy your own platform by integrating our REST APIs
                        seamlessly and enhancing the customizability of your
                        policy engine
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  _ENDS > DEAL STRUCTURE SECTION < SHB */}

      <Footer />
    </div>
  );
};

export default KycAml;
